import React from "react";

export const SpoolSVG = ({ color = "rgb(141, 117, 79)" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_2"
      data-name="Layer 2"
      viewBox="0 0 733.77 1196.65"
    >
      <defs>
        <style>
          {
            ".cls-2{stroke:#424242}.cls-2,.cls-3,.cls-5{fill:none}.cls-2,.cls-3,.cls-5,.cls-6{stroke-miterlimit:10}.cls-3,.cls-5,.cls-6{stroke:#000}.cls-8{stroke:#070707;stroke-linejoin:round}.cls-5,.cls-8{stroke-linecap:round}.cls-8{fill:#c1c1c1}.cls-5{stroke-width:2px}"
          }
        </style>
      </defs>
      <g id="Layer_2-2" data-name="Layer 2">
        <path d="m36.42 473.94 12.41 5.67-3.24 90.06-16.72-8.36 7.55-87.37z" />
        <path d="M191.14 8.24c-2.94-5.7-34.5-3.49-39.03-2.43-5.33 1.24-12.23 2.73-23.66 10.92-7.5 5.38-14.57 12.61-23.46 24.07-6.13 7.89-10.5 15.75-11.93 18-12.41 19.46-18.81 38.96-22.65 49.15-14.74 39.09-23.68 71.55-24.54 74.7-9.03 33.08-13.94 58.59-17.8 78.88-6.16 32.37-9.51 56.96-12 75.51-1.75 12.97-6.32 48.17-9.98 94.79-1 12.69-3.25 43.16-4.72 86.83-3.44 102.37.6 182.99 1.48 199.82C4.68 753.39 7.52 805.13 16.6 873c9.26 69.15 19.4 113.09 26.7 141.17 0 0 9.69 37.24 34.79 99.1 3.92 9.65 9.52 22.99 20.22 38.43 16.84 24.29 26.58 32.51 33.57 36.4 10.31 5.75 17.77 7.28 21.03 7.69 4.73.58 18.97 2.53 22.11-2.29 6.23-9.55-34.4-40.39-60.54-72.94-11.71-14.58-28.89-39.94-53.8-155.33-11.41-52.84-24.27-113.52-31.96-201.84-7.63-87.76-5.88-153.77-4.04-215.6 3.35-112.76 13.83-191.22 18.2-221.66 11.59-80.64 17.84-121.97 40.45-171.1 27.21-59.14 41.4-89.98 73.21-117.3 8.17-7.01 37.9-23.03 34.58-29.46Z" />
        <path d="m97.37 1000.73-3.78 32.49 28.42 66.86 5.08-44.52-29.72-54.83z" />
        <path
          d="M256.87 85.36S221.01 5.81 182.04 5.81c-21.03 0-48.25 13.08-64.18 41.8-38.42 69.26-52.44 124.85-76.99 242.56-15.64 74.97-17.61 137.04-21.03 232.58-2.07 57.68-4.7 138.04 3.64 243.91 0 0 3.84 101.93 43.28 260.09 0 0 5.76 32.97 34.79 96.27 7.67 16.72 20.51 41.11 40.04 55.82 9.49 7.15 20.52 16.07 39.64 14.56 22.98-1.81 44.09-20.63 57.03-45.3 9.44-18 18.61-33.17 18.61-33.17l-55.01.4c-26.7 18.2-49.9.25-55.01-4.85-16.38-16.38-35.51-37.65-46.52-71.19-24.24-73.85-32.73-110.78-35.19-122.56-5.06-24.18-13.98-67.05-20.63-141.17-10.78-120.3-8.49-211.51-7.28-246.34.53-15.19 2.39-63.72 10.92-135.51 9.23-77.64 13.89-119.73 45.17-214.65 10.78-32.72 43.99-98.02 88.72-95.33 47.44 2.86 74.83 1.62 74.83 1.62Z"
          style={{
            fill: "#828282",
          }}
        />
        <path d="M573 1.49c-.37-1.92-20.14-3.01-35.41 3.3-11.66 4.82-19.65 12.57-29.93 25.48-23.22 29.15-34.38 54.2-34.38 54.2-10.8 24.24-21.49 47.12-41.66 127.42-9.15 36.41-12.98 54.56-16.18 71.6-1.62 8.62-4.02 35.04-9.3 88.18-2.55 25.63-5.4 59.39-7.69 105.98-1.99 40.54-5.54 89.37-4.45 155.12 1.09 65.95 3.94 121.26 6.88 153.51 6.87 75.36 18.51 128.06 21.44 144.81 9.84 56.38 17.96 94.19 30.34 129.84 6.51 18.76 14.44 34.3 30.34 68.16 9.3 19.82 15.43 25.54 27.1 39.03 6.94 8.02 16.33 16.68 30.74 21.44 20.01 6.61 38.86 1.08 38.83.4-.02-.46-8.68 1.18-19.42-1.62-13.2-3.44-22.25-11.69-29.53-19.42-24.4-25.9-36-55.42-36-55.42-11.93-27.71-20.6-53.44-29.53-86.56-11.83-43.88-20.8-78-25.48-104.36-2.23-12.58-8.52-48.86-14.16-97.08-3.09-26.45-7.64-70.6-10.11-125.8-1.9-42.31-1.77-73.2-1.62-112.45.17-43.14.28-71.65 2.43-110.83.74-13.52 3.81-66.5 13.35-137.12 4.05-29.99 9.21-67.61 19.82-116.9 0 0 12.78-48.94 33.57-111.64 5.6-16.89 14.05-40.32 32.76-65.93 17.9-24.5 30.39-33.36 36-36 9.69-4.56 21.53-5.92 21.25-7.35Z" />
        <path
          id="Culoare5"
          d="M473.5 84.68s-287.58-1.96-298.11-.62c-25.77 3.28-63.09 53.17-81.08 107.41-6.55 19.76-11.72 32.74-19.64 64.72C60.38 313.89 54.01 363.1 50 401c-9.14 86.34-10.9 160.26-10.52 216 .28 40.19 1.21 98.29 10.52 171.1 6.69 52.38 6.88 87.37 34.8 187.8 5.59 20.09 24.15 74.51 46.91 105.46 15.11 20.55 43.28 33.17 43.28 33.17l299.33.4s-5.26-9.71-12.54-27.91c-5.83-14.59-16.36-33.36-32.36-113.66-7.18-36.02-15.14-76.43-22.25-134.29-3.14-25.59-9.1-78.85-11.73-147.64-2.22-58.26-1.03-100.76.4-151.69 1.52-54.17 2.67-94.95 8.09-150.47 6.6-67.62 10.11-101.73 22.25-151.28 26.33-107.51 47.33-153.3 47.33-153.3Z"
          fill={color}
        />
        <path
          d="M583.07 2.77c-2.7-.52-12.77-2.21-24.67 1.62-5.93 1.91-13.8 5.66-26.29 18.61-16.29 16.88-24.91 33.29-25.89 35.19-30.82 59.78-44.9 113.26-44.9 113.26-3.77 14.31-14.78 57.3-25.48 124.99-2.85 18.03-11.14 72.34-16.58 144.81-1.2 15.95-4.56 63.42-5.26 125.8-.15 13.47-2.67 68.77 1.19 141.88 1.58 29.9 5.72 67.71 11.35 118.21 5.02 45.06 10.46 92.49 24.67 153.71 6.41 27.59 17.48 59.25 39.64 122.56 1.6 4.58 10.08 28.21 29.12 53.39 17.32 22.9 29.65 28.94 38.43 31.55 4.35 1.29 16.16 4.63 29.53.4 9.12-2.89 15.12-8.08 19.42-12.13 25.73-24.29 38.43-50.16 38.43-50.16 21.51-43.81 33.09-82.98 35.19-90.2 15.09-51.84 22.97-92.46 25.08-103.55 10.35-54.44 14.3-95.88 18.2-137.93 5.25-56.6 6.75-99.74 7.69-127.82 2.19-66.08 1.13-115.91.81-129.44-.73-30.42-2.03-80.53-8.49-145.62-8.51-85.64-20.75-146.54-23.87-160.58-9.67-43.58-17.39-75.64-45.3-146.02 0 0-14.44-41.68-46.92-69.57-9.99-8.58-18.47-11.67-25.08-12.94Z"
          style={{
            fill: "#828282",
            stroke: "#000",
            strokeMiterlimit: 10,
          }}
        />
        <path d="M572.51 444.55c-16.72.16-28.53 46.3-35.6 73.89 0 0-23.19 118.11 12.94 210.34 4.76 12.15 12.76 24.03 22.11 24.27 6.46.16 17.33-4.36 25.89-28.58 35.06-99.24 10.5-212.02 10.5-212.02-4.85-24.81-20.62-68.04-35.85-67.89ZM550.94 50.3c.1 1.1 20.84-4.89 39.91 4.85 12.67 6.47 23.2 19.26 28.31 27.61 39.81 64.98 55.28 139.04 55.28 139.04 7.23 29.42 15.65 68.93 22.11 116.49L614.3 493.62l1.62 9.98c29.3-55.19 59.42-111.73 88.72-166.92-8.34-55.71-18.92-101.86-28.04-136.45-2.21-8.38-13.75-51.13-39.91-100.85-15.71-29.86-38.29-47.19-49.35-50.16-18.85-5.06-36.5.03-36.4 1.08Z" />
        <path
          d="M616.72 499.83c-.53-1.08-14.55-105.98-49.87-92.22L552.29 50.85M705.39 363.56l-84.87 159.73c12.4 82.52 4.22 143.41-11.87 203.87l71.08 253.34"
          className="cls-5"
        />
        <path d="M675.39 967.97c7.28-20.83 69.2-309.4 23.9-594.03l8.06-14.73c16.86 75.43 31.96 398.7-27.91 626.56l-4.05-17.8Z" />
        <path d="M667.43 915.92c11.12-74.63 44.78-212.52 19.01-495.91l10.52-19.82c9.57 80.97 27.71 335.93-23.06 542.16l-6.47-26.43Z" />
        <path
          id="Culoare4"
          d="m686.45 420.01-60 109.75c9.98 49.35 7.03 150.2-10.79 197.39l51.28 186.87c11.42-28.03 47.58-254.78 19.51-494.01Z"
          fill={color}
        />
        <path
          d="M540.15 61.09c8.63 180.13 15.64 350.56 15.64 350.56-26.2 21.3-36.4 98.43-39.91 142.38l5.93 4.85c5.39-68.76 23.73-138.88 39.91-145.08 0 0-14.83-326.83-14.02-359.73-.06.06-4.69 4.35-4.75 4.41-.02.02-2.78 2.58-2.8 2.6Z"
          className="cls-6"
        />
        <path
          d="M542.96 58.49c-86.4 81.61-109.86 300.71-116.6 442.96l89.53 52.58"
          className="cls-3"
        />
        <path
          d="m534.22 92.1 12.94 298.52c-15.91 13.21-37.75 109.21-35.87 133.75-1.05-.55-12.67-6.74-12.67-6.74 1.89-40.18 21.3-114.88 36.13-127.55 0 0-5.66-132.67-11.87-286.65l11.33-11.33Z"
          className="cls-6"
        />
        <path
          id="Culoare3"
          d="m498.63 517.63-68.09-36.61C447.39 221 493.1 149.81 521.87 105.56l12.89 284.52c-17.39 29.93-28.72 63.1-36.13 127.55Z"
          fill={color}
        />
        <path
          d="m503.02 519.97-72.49-38.95c9.03-165.28 38.7-303.17 92.36-377.6"
          className="cls-3"
        />
        <path d="M520.5 580.7c2 48.59-1.11 114.37 26.93 186.64 0 0-33.21 245.04-45.03 319.55l-5.93-11.87c12.07-77.63 43.69-307.42 43.69-307.42-26.43-59.87-26.77-152.41-26.36-190.13l6.71 3.22Z" />
        <path
          d="M500.08 1080.85c-54.91-91.71-85.64-378.1-75.07-555.13 31.46 19.06 62.92 36.07 94.38 55.13"
          className="cls-3"
        />
        <path
          id="Culoare2"
          d="m426.86 567.92 68.36 39.47c0 39.64 3.98 102.74 23.26 169.48l-33.78 245.12c-51.22-137.47-60.37-353.25-57.85-454.08Z"
          fill={color}
        />
        <path
          d="m507.26 606.68-12.34 1.01c-1.42 47.53 6.67 107.8 23.26 169.48l-33.78 245.12 8.49 23.66 37.82-267.98c-16.99-61.48-23.16-124.58-23.46-171.3Z"
          className="cls-6"
        />
        <g
          style={{
            isolation: "isolate",
          }}
        >
          <path
            d="M494.92 608.2c-.09 0-.18-.02-.26-.07l-68.06-41.06a.507.507 0 0 1-.24-.43l.05-7.43c0-.18.1-.34.25-.43a.542.542 0 0 1 .51.01l79.73 47.52c.19.11.28.33.23.54a.49.49 0 0 1-.45.38s-11.75.96-11.77.96Z"
            style={{
              fill: "#c1c1c1",
            }}
          />
          <path
            d="m426.91 559.21 79.73 47.52-11.73.96-68.06-41.06.05-7.43m0-1a1.01 1.01 0 0 0-1 .99l-.05 7.43c0 .35.18.68.48.86l68.06 41.06c.16.09.34.14.52.14h.08l11.73-.96c.43-.04.79-.35.89-.77.1-.42-.09-.86-.46-1.08l-79.73-47.52a1.03 1.03 0 0 0-.51-.14Z"
            style={{
              fill: "#070707",
            }}
          />
        </g>
        <path
          d="m642.9 987.69 3.16 12.09c-17.19 55.55-42.41 111.51-83.33 123.24-13.55-1.75-21.17-8.09-21.17-8.09 17.19.13 59.39-1.62 101.33-127.24Z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M426.36 566.64c-.29 141.78 8.09 314.83 59.5 459.71"
          style={{
            stroke: "#070707",
            strokeLinejoin: "bevel",
            fill: "none",
          }}
        />
        <path
          id="Culoare1"
          d="M593.01 801.04s49.86 165.42 49.89 186.65c-29.52 82.86-49.83 122.45-98.72 128.94-3.34.44-24.93-21.11-31.53-31.9l36.4-262.66c13.17 1.62 28.73 10.11 43.96-21.02Z"
          fill={color}
        />
        <path d="m593.01 801.04 7.28-15.91c19.15 57.44 58.25 214.65 58.25 214.65-21.57 76.85-58.79 124.85-95.8 123.24 41.32-13.75 66.67-69.84 83.33-123.24l-5.02-19.19s-11.35-43.34-20.3-77.2c-5.99-22.66-14.95-56.1-27.74-102.35Z" />
        <path
          d="M566.65 1122.41c-17.8 2.97-38.36-15.57-54-37.69l37.48-270.47c18.34 19.42 37.21 1.82 44.49-15.44"
          className="cls-3"
        />
        <path
          d="m607.03 745.76 68.49 255.64c-20.76 79.55-62.97 154.52-103.15 151.01 40.85-9.84 73.08-65.8 96.81-151.42l-65.53-246.61 3.37-8.63Z"
          className="cls-6"
        />
        <path
          d="M572.38 1152.41c-18.47 2.16-46.79-20.76-64.82-54.2l43.92-320.9c8.33 11.59 29.93 38.83 52.18-22.92"
          className="cls-3"
        />
        <path
          d="M549.05 822.07c19 4.26 26.35-1.23 26.35-1.23s-14.95 7.51-25.27-6.58l-1.08 7.81ZM550.41 785.13c13.88 13.69 24.5 8.13 24.5 8.13s-12.83-.24-23.43-15.95l-1.07 7.82Z"
          className="cls-8"
        />
        <path
          d="M643.97 984.95c-27.15 77.71-71.27 165.63-130.79 95.89"
          className="cls-3"
        />
        <g id="Linii_Filament" data-name="Linii Filament">
          <path
            d="M191.4 1114.93c-151.97-41.26-198.66-918.2 0-1030.67"
            className="cls-2"
          />
          <path
            d="M213.9 1115.9C61.93 1074.64 16.55 196.06 215.21 83.59"
            className="cls-2"
          />
          <path
            d="M232.33 1115.9C80.36 1074.64 34.75 196.2 233.41 83.74"
            className="cls-2"
          />
          <path
            d="M252.39 1115.02c-151.97-41.26-197.01-918.97 1.65-1031.43"
            className="cls-2"
          />
          <path
            d="M271.84 1114.93c-151.97-41.26-195.43-918.88 3.24-1031.34"
            className="cls-2"
          />
          <path
            d="M290.48 1114.81C138.51 1073.55 96.84 196.2 295.51 83.73"
            className="cls-2"
          />
          <path
            d="M308.78 1114.71c-151.97-41.26-193.94-918.44 4.72-1030.9"
            className="cls-2"
          />
          <path
            d="M327.66 1115.02c-151.97-41.26-191.38-918.97 7.28-1031.43"
            className="cls-2"
          />
          <path
            d="M345.19 1114.76c-151.97-41.26-189.7-918.7 8.97-1031.16"
            className="cls-2"
          />
          <path
            d="M367.57 1115.02c-151.97-41.26-193.88-918.13 4.79-1030.59"
            className="cls-2"
          />
          <path
            d="M386.7 1114.81c-151.97-41.26-190.55-918.76 8.11-1031.22"
            className="cls-2"
          />
          <path
            d="M408.56 1114.93c-151.97-41.26-191.65-918.04 7.01-1030.5"
            className="cls-2"
          />
          <path
            d="M426.48 1114.87c-151.97-41.26-191.23-917.97 7.43-1030.44"
            className="cls-2"
          />
          <path
            d="M451.62 1115.02c-151.97-41.26-197.23-917.33 1.43-1029.79"
            className="cls-2"
          />
          <path
            d="M466 1114.93c-151.97-41.26-194.35-917.24 4.31-1029.7"
            className="cls-2"
          />
          <path
            d="M478.94 1112.77c-138.2-44.18-168-892.31-12.13-998.29"
            className="cls-2"
          />
          <path
            d="M442.1 1026.35c-85.72-196.99-84.1-652.45 3.61-861.19"
            className="cls-2"
          />
        </g>
      </g>
    </svg>
  );
};
